<template>
    <div class="offline-training">
        <van-nav-bar
            :title="name"
            left-arrow
            @click-left="onClickLeft"
        />
        <div class="offline-training-content">
            <div class="title">
                {{name}}
            </div>
            <div class="border"></div>
            <div class="content">
                <p class="question">考试时间：</p>
                <p class="answer">{{examTime}}</p>
                <p class="question">考试须知：</p>
                <p class="answer">{{examNotice}}</p>
                <div class="start-button">
                    <van-button round type="primary" class="start-button-primary" @click="startDrawingQuestion()">开始抽题</van-button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name:'offlineTraining',
    data(){
        return {
            name:'',//姓名
            examTime:'',//考试时间
            examNotice:'',//考试须知
            setmId:'',
        }
    },
    async created() {
        await this.findClassExamInfo()
    },
    methods:{
        onClickLeft(){
            this.$router.push({
                path:"/learning/task/detail",
                query:JSON.parse(this.$route.query.taskQuery)
            })
        },
        findClassExamInfo(){
            const params = {
                id:this.$route.query.id ? this.$route.query.id : ''
            }
            this.$api.offlineTraining.findClassExamInfo(params).then(res => {
                if(res.success){
                    this.name = res.data.name
                    this.examTime = res.data.examTime
                    this.examNotice = res.data.examNotice
                    this.setmId = res.data.id
                }
            })
        },
        startDrawingQuestion(){
            this.$toast({
                message: '正在抽题中...',
                position: 'bottom',
                forbidClick:true,
                loading:false
            });
            const params = {
                id:this.setmId
            }
            this.$api.offlineTraining.extractQuestion(params).then(res => {
                if(res.success){
                    console.log(res.data);
                    this.$router.push({
                        path:'/offlineStem',
                        query:{
                            id:this.setmId,
                            name:this.name,
                            taskQuery:this.$route.query.taskQuery
                        }
                    })
                }
            })
        }
    }
}
</script>
<style lang="stylus" scoped src="../asset/css/offlineTraining.styl">
</style>